<div class="error-container">
  <div class="error-image">
    <img src="assets/newassets/images/error.gif" alt="Error illustration" width="360">
  </div>
  <div class="error-content">
    <h1 class="error-title">ERROR 404! PAGE NOT FOUND</h1>
    <a [routerLink]="['/landingPage']" class="error-link">Go back to Landing Page</a>
  </div>
</div>